var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":_vm.btnColor,"disabled":_vm.disabled,"width":"96px","height":"36px","outlined":""},on:{"click":_vm.emitFunc}},[_vm._v(" "+_vm._s(_vm.action)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }